import { Injectable, inject } from "@angular/core";
import { ProfileSettingsFormGroup } from "./profile-settings-form-group.interface";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { phoneNumberValidator } from "../../validators/phone-number-validator";

@Injectable()
export class ProfileSettingsFormModel {
  readonly fieldNames = {
    name: 'name',
    surname: 'surname',
    birthDate: 'birthDate',
    phoneNumber: 'phoneNumber',
    email: 'email',
    countryId: 'countryId',
    cityId: 'cityId',
    interfaceLanguage: 'interfaceLanguage'
  };

  form: FormGroup<ProfileSettingsFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<ProfileSettingsFormGroup>({
      name: new FormControl(null, Validators.maxLength(128)),
      surname: new FormControl(null, Validators.maxLength(128)),
      birthDate: new FormControl(null),
      phoneNumber: new FormControl(null, phoneNumberValidator),
      email: new FormControl({value: '', disabled: true }, {
        nonNullable: true,
        validators: [Validators.required, Validators.email],
      }),
      // countryId: new FormControl(null),
      // cityId: new FormControl(null),
      interfaceLanguage: new FormControl()
    });
  }
}
